import { render } from "./NotificationsBody.vue?vue&type=template&id=905a5742&scoped=true"
import script from "./NotificationsBody.vue?vue&type=script&lang=js"
export * from "./NotificationsBody.vue?vue&type=script&lang=js"

import "./NotificationsBody.vue?vue&type=style&index=0&id=905a5742&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-905a5742"]])

export default __exports__